<template>
	<div class="fondoModal">
		<div>
			<div style="max-width:400px;">
				<div class="card">
					<div class="card-header bg-warning text-center">
						Cambio de contraseña
					</div>
					<div class="card-body text-left">
						<div class="alert alert-info">
							<span class="fa fa-info-circle mr-1"></span>
							Es necesario que actualices tu contraseña
						</div>
						<div class="form-group">
							<label for="">Contraseña antigua</label>
							<input type="password" class="form-control form-control-sm" v-model="form.passwordAnterior">
						</div>
						<div class="form-group">
							<label for="">Nueva contraseña</label>
							<input type="password" class="form-control form-control-sm" v-model="form.passwordNueva1">
						</div>
						<div class="form-group">
							<label for="">Repítela</label>
							<input type="password" class="form-control form-control-sm" v-model="form.passwordNueva2" @keypress.enter="cambiar()">
						</div>
					</div>
					<div class="card-footer">
						<button class="btn btn-sm btn-primary" @click="cambiar()">
							<span class="fa fa-lock mr-1"></span>
							Cambiar
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import API from './apiUsuario'

export default {
	data: function () {
		return {
			form: {
				passwordAnterior: '',
				passwordNueva1: '',
				passwordNueva2: ''
			}
		}
	},

	methods: {
		cambiar () {
			API.updatePassword(this.form)
				.then(res => {
					this.$store.commit('alertas/alert', {
						titulo: 'Cambio de password correcto',
						mensaje: 'Se ha actualizado tu contraseña correctamente'
					})

					this.$store.dispatch('session/getSesion')
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/mi-perfil/cambio-pass.vue